import { Component, computed, OnInit } from '@angular/core';
import { apiUrl } from '@app/app.constants';
import { PortalNotificationType } from '@app/core/interfaces/portal-notification';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { PortalTimeAgoPipe } from '@app/shared/pipes/portal-time-ago.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { groupBy, sortBy } from '@app/utils/common';
import { componentState } from '@app/utils/component-state';
import { currentLanguage } from '@app/utils/translate';
import { NotificationLiveViewItemComponent } from '@business/notification/components/notification-live-view/notification-live-view-item.component';
import {
  getTranslationsByKey,
  PortalNotificationTranslationLike,
} from '@business/notification/models/portal-notification-helpers';
import { PortalNotificationService } from '@business/notification/portal-notification.service';

interface NotificationDialogInput {
  /**
   * Default is the current language
   */
  language?: string;

  /**
   * Default is true
   */
  markAsSeen?: boolean;
  notificationId: number;
  publicationDate?: Date;
  translations: PortalNotificationTranslationLike[];
  type: PortalNotificationType;
}

@Component({
  selector: 'portal-notification-dialog',
  standalone: true,
  imports: [SharedModule, NotificationLiveViewItemComponent, PortalTimeAgoPipe],
  templateUrl: './notification-dialog.component.html',
  styles: `
    .title-image {
      margin-block-end: 0.5rem;
      border-radius: var(--p-border-radius);
      max-width: 100%;
    }
  `,
})
export class NotificationDialogComponent
  extends DialogComponent<NotificationDialogInput, void>
  implements NotificationDialogInput, OnInit
{
  readonly language?: string;
  readonly markAsSeen: boolean = true;
  readonly notificationId!: number;
  readonly publicationDate?: Date;
  readonly translations!: PortalNotificationTranslationLike[];
  readonly type!: PortalNotificationType;

  state = componentState();

  currentLanguage = currentLanguage();
  activeLanguage = computed(() => (this.language != null ? this.language : this.currentLanguage()));
  currentTranslations = computed(() => {
    const translationsByLanguage = groupBy(this.translations, (translation) => translation.language);

    return getTranslationsByKey(translationsByLanguage, this.activeLanguage()).sort(sortBy('orderIndex'));
  });
  title = computed(() => this.currentTranslations()[0]);
  titleImage = computed(() =>
    this.title()?.media != null ? apiUrl(`/reseller/media/${this.title().media.id}/download`) : null
  );

  protected readonly PortalNotificationType = PortalNotificationType;

  constructor(private portalNotificationService: PortalNotificationService) {
    super();
  }

  ngOnInit(): void {
    if (this.markAsSeen) {
      this.state.handle(this.portalNotificationService.markAsSeen(this.notificationId)).subscribe();
    }
  }
}
